// src/Services/fetchCreateEmpleado.js
import { USERS } from "../Constants/Endpoinst";
import { ApiRequestInterceptor } from "./apiRequest";

export const fetchCreateEmpleado = async (body, token) => {
  const method = "POST";
  const headers = {
    Authorization: `Bearer ${token}`,
    "Content-Type": "application/json"
  };

  const response = await ApiRequestInterceptor(
    USERS.createEmpleado,
    method,
    body,
    headers
  );

  // Ajusta según lo que devuelva tu interceptor: status / code / ok
  const status = response.status ?? response.code; // fallback
  if ((status >= 200 && status < 300) && response.data?.message) {
    return response.data;
  }

  const errorMessage = response?.data?.error || "Error desconocido";
  throw new Error(errorMessage);
};
